
import { RecordValidationIcon } from '#record/constants'
import { SearchIcon } from '#search/constants'
import { DevSettingsPanel } from '#settings/dev'
import { SearchSettingsPanel } from '#settings/search'
import { AppSettings } from '#settings/settings'
import { SystemSettingsPanel } from '#settings/system'
import { ValidationSettingsPanel } from '#settings/validation'
import { useEnv } from 'apprise-frontend-core/env'
import { SettingsModule } from 'apprise-frontend-streams/settings/model'
import { DevOnlyIcon } from 'apprise-ui/utils/icons'
import { AiFillAppstore } from 'react-icons/ai'



export const systemSettingsModule: SettingsModule<AppSettings> = {

    Icon: AiFillAppstore,
    Render: SystemSettingsPanel,
    defaults: {
        dateFormat: 'medium'
    },
    type: 'system',
    name: 'rav.appsettings'
}


export const useValidationSettings = () : SettingsModule<AppSettings> => {

    const env = useEnv()

    return {

        Icon: RecordValidationIcon,
        Render: ValidationSettingsPanel,
        defaults: {
            photosRequired: env.name !== 'development',
            validateIMOChecksum: env.name === 'production',
            minPhotoQuality: 0,
            validatePhotoQuality: true
        },
        type: 'validation',
        name: 'rav.validationsettings'
    }
}



export const searchSettingsModule: SettingsModule<AppSettings> = {

    Icon: SearchIcon,
    Render: SearchSettingsPanel,
    type: 'search',
    name: 'rav.searchsettings'
}



export const useDevSettings = (): SettingsModule => {

    const env = useEnv()


    return {

        Icon: DevOnlyIcon,
        name: 'rav.devsettings',
        type: 'dev',
        renderIf: env.name!=='production',
        defaults: {
            autoMatchAndValidate: true
        },
        Render: DevSettingsPanel

    }
}

// export const useExportCompleteSubsciption = (): EventSubscription => {

//     const t = useT()
//     const fb = useFeedback()

//     return  {

//         topic: 'export',
//         onEvent: () => fb.showNotification(t('rav.setting_export_trigger_done'),{ duration: false})
//     }
    
// }